
import UserProfileImage from './user-profile-image'
import DragAndDropImageUpload from './drag-and-drop-image-upload'
import SettingsImageActions from './settings-image-actions'
import SettingsTablePaging from './settings-table-paging'
import LocationSearch from './location-search'
import SvgIcon from './svg-icon'
import Icons from './icons'
import RatingStars from './rating-stars'

export default {
    UserProfileImage,
    DragAndDropImageUpload,
    SettingsImageActions,
    SettingsTablePaging,
    LocationSearch,
    SvgIcon,
    Icons,
    RatingStars,
}
